import axios from '../../../axios';
import IJobBoardDTO from '../../NativeSearchSettingsService/types/IJobBoardDTO';
import { CWJobSearch } from '../types/CWJobSearch';

export const searchCWJobSearchBuilder = async (query: CWJobSearch) =>
  await axios.post('/candidatesearch/api/cw-jobs/search', query);

export const getCWJobsUsage = async (jobBoard: IJobBoardDTO) =>
  await axios.post('/candidatesearch/api/cw-jobs/get-usage-report', jobBoard);
